import AbstractKeys from '../all/AbstractKeys';

class NetrangeKeys extends AbstractKeys {
  constructor() {
    super();
    this.keys = {
      UP: 38,
      DOWN: 40,
      LEFT: 37,
      RIGHT: 39,
      OK: 13,
      RED: 118,
      GREEN: 119,
      YELLOW: 120,
      BLUE: 121,
      BACK: 8,
      EXIT: null,

      ZERO: 48,
      ONE: 49,
      TWO: 50,
      THREE: 51,
      FOUR: 52,
      FIVE: 53,
      SIX: 54,
      SEVEN: 55,
      EIGHT: 56,
      NINE: 57,

      PLAY: 405,
      RWD: 412,
      FWD: 417,
      STOP: 413,
      PAUSE: 19,

      CH_UP: 427,
      CH_DOWN: 428,

      NEXT: 425,
      PREVIOUS: 424,
      FFW: 417
    };
    if (
      navigator.userAgent.indexOf('Presto') !== -1 ||
      navigator.userAgent.indexOf('Linux armv7l') !== -1
    )
      this.keys.BACK = 8;
  }
}

export default NetrangeKeys;



// WEBPACK FOOTER //
// ./src/devices/netrange/Keys.js